module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_kagawa-6f5964e26670ecc6a5f01700120f3211.png";